import {Button, Form, Input, Modal} from 'antd';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {useInventoryForm} from './useInventoryForm';
interface IInventoryDetailProps {
  medicineId: string;
  date: string;
  open: boolean;
  onCancel: () => void;
}

const InventoryDetailModal: FC<IInventoryDetailProps> = ({
  medicineId,
  date,
  open,
  onCancel,
}) => {
  const {t} = useTranslation();
  const {form, onSubmit} = useInventoryForm({
    medicineId,
    date,
    onCancel,
  });
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t('Inventory detail')}
      footer={null}
    >
      <Form
        form={form}
        onFinish={onSubmit}
        autoComplete="off"
        labelCol={{span: 8, offset: 2}}
        wrapperCol={{span: 12}}
        labelAlign="left"
      >
        <Form.Item name="box_count" label={t('Box count')}>
          <Input type="number" />
        </Form.Item>
        <Form.Item name="package_count" label={t('Package count')}>
          <Input type="number" />
        </Form.Item>
        <Form.Item name="piece_count" label={t('Piece count')}>
          <Input type="number" />
        </Form.Item>
        <Form.Item name="expiration_date" label={t('Expiration date')}>
          <Input type="date" />
        </Form.Item>

        <div style={{textAlign: 'center'}}>
          <Button type="primary" htmlType="submit">
            {t('Register')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default InventoryDetailModal;
